import script from "./ButtonHomeComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonHomeComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ButtonHomeComponent.vue?vue&type=style&index=0&id=a73bd4a8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a73bd4a8"]])

export default __exports__